function e(e){return e!=null}export{e as isNonNullish};
//# sourceMappingURL=isNonNullish-C9wd575s.js.map